import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { stringifyIfPresent } from 'src/lib/common';
import { getSingleProp } from 'src/lib/graphql';

const MUTATION = gql`
  mutation CrmTrackEvent($eventName: CrmEventsEnum!, $attributes: JSON) {
    crmTrackEvent(eventName: $eventName, attributes: $attributes) {
      id
    }
  }
`;

export function trackCrmEvent(eventName: string, attributes: object) {
  return executeGqlMutation({
    mutation: MUTATION,
    variables: {
      eventName,
      attributes: stringifyIfPresent(attributes),
    },
  }).then(({ data }) => getSingleProp(data));
}
